import axios from 'axios';
import { after, before } from './interceptors';
import { get } from '../../utils/data';
import { XhrConfig } from '../../types';

function createXHR(commonParams: object, xhrConfig?: XhrConfig) {
  const initProps = get('initProps') || {};
  const { getDynamicConfig, cacheRedirectDomain } = xhrConfig ?? {};
  const { host, isBoe } = initProps;
  const xhr = axios.create({
    withCredentials: true,
  });

  const baseURL =
    host ||
    (window &&
      `${isBoe ? window.location.protocol : 'https:'}//${
        window.location.hostname
      }`);

  xhr.interceptors.request.use(config => {
    config.baseURL = baseURL;
    return before(config, commonParams, getDynamicConfig);
  }, undefined);

  xhr.interceptors.response.use(config => {
    return after(config, xhr, cacheRedirectDomain);
  }, undefined);
  return xhr;
}

export default createXHR;
